// extracted by mini-css-extract-plugin
module.exports = {"row":"InvoiceReceptionConcept_row__86-Nq","header":"InvoiceReceptionConcept_header__2XJZM"};